// table info
export const tableHeaders = [
  "Name",
  "Code",
  "Contact",
  "Address",
  "Phone",
  "Town",
  "Mail",
];

export const columnNames = [
  "name",
  "code",
  "contact",
  "address",
  "phone",
  "town",
  "mail",
];

export const viewRoute = "/file-maintenance/supplier-file/view";
